var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:lightbulb-night-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0013 66.6667H40.0013V70C40.0013 71.8334 38.5013 73.3334 36.668 73.3334H23.3346C21.5013 73.3334 20.0013 71.8334 20.0013 70V66.6667ZM36.668 49.6334V53.3334H23.3346V45.2667C17.4346 42.7 13.3346 36.8334 13.3346 30C13.3346 20.8 20.8013 13.3334 30.0013 13.3334C33.0013 13.3334 35.768 14.2 38.2013 15.5667C40.0013 14 42.2013 12.7 44.5013 11.6667C40.5346 8.56669 35.5013 6.66669 30.0013 6.66669C17.1013 6.66669 6.66797 17.1 6.66797 30C6.66797 37.9334 10.6346 44.9 16.668 49.1334V56.6667C16.668 58.5 18.168 60 20.0013 60H40.0013C41.8346 60 43.3346 58.5 43.3346 56.6667V54.4C40.8346 53.2 38.568 51.6667 36.668 49.6334ZM69.7346 33.1334L68.068 27.6667L72.4013 24.0667L66.8013 23.9334L64.7013 18.6667L62.8346 24.0334L57.2346 24.4L61.668 27.8334L60.3346 33.3334L65.0013 30.1L69.7346 33.1334ZM63.7346 40.8334C61.4658 40.4602 59.3093 39.584 57.4232 38.2689C55.5371 36.9538 53.9692 35.2332 52.8346 33.2334C50.4013 29.0334 50.168 24.1667 51.668 19.9C52.1346 18.7667 51.1346 17.6334 50.0013 17.8C38.5346 20 33.3346 33.7667 40.7346 43.1667C46.768 50.6334 58.3346 50.9 64.6346 43.3334C65.4013 42.4667 64.9013 41 63.7346 40.8334Z",
    fill: "#64B3E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNight);
export default __webpack_public_path__ + "static/media/home-night.998b8fe138dfca7dd72c8ce532e7eeb1.svg";
export { ForwardRef as ReactComponent };